var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 4.33337C11.7732 4.33337 12.6598 3.44004 12.6598 2.33337C12.6598 1.22671 11.7732 0.333374 10.6665 0.333374C9.55984 0.333374 8.6665 1.22671 8.6665 2.33337C8.6665 3.44004 9.55984 4.33337 10.6665 4.33337ZM5.33317 4.33337C6.43984 4.33337 7.3265 3.44004 7.3265 2.33337C7.3265 1.22671 6.43984 0.333374 5.33317 0.333374C4.2265 0.333374 3.33317 1.22671 3.33317 2.33337C3.33317 3.44004 4.2265 4.33337 5.33317 4.33337ZM5.33317 5.66671C3.77984 5.66671 0.666504 6.44671 0.666504 8.00004V9.66671H9.99984V8.00004C9.99984 6.44671 6.8865 5.66671 5.33317 5.66671ZM10.6665 5.66671C10.4732 5.66671 10.2532 5.68004 10.0198 5.70004C10.7932 6.26004 11.3332 7.01337 11.3332 8.00004V9.66671H15.3332V8.00004C15.3332 6.44671 12.2198 5.66671 10.6665 5.66671Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.6323ccbd8d239a8c8dc32ee3334ae8ba.svg";
export { ForwardRef as ReactComponent };